import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import About from './components/About';
import Stats from './components/Stats';
import Testimonials from './components/Testimonials';
import Careers from './components/Careers';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Demo from './components/Demo';

const App: React.FC = () => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const storedLang = localStorage.getItem('lang');
    if (storedLang) setLanguage(storedLang);
  }, []);

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    localStorage.setItem('lang', lang);
  };

  return (
    <Router>
      <Routes>
        <Route path="/demo" element={<Demo language={language} />} />
        <Route path="/" element={
          <div className="bg-blue-50 text-blue-900 min-h-screen">
            <Navbar language={language} onLanguageChange={handleLanguageChange} />
            <Hero language={language} />
            <About language={language} onLanguageChange={handleLanguageChange} />
            <Products language={language} />
            <section id="playground" className="py-24 px-4 bg-blue-50">
              <div className="max-w-6xl mx-auto">
                <div className="text-center mb-16 animate-fade-in">
                  <h2 className="text-heading-lg text-blue-900 mb-4 section-heading-underline centered">
                    {language === 'zh' ? 'AI 演示場' : 'AI Playgrounds'}
                  </h2>
                  <p className="text-body-lg text-gray-700 max-w-2xl mx-auto">
                    {language === 'zh'
                      ? '通過互動演示親身體驗我們的技術。探索功能，測試操作，並可視化我們的解決方案如何改變您的業務。'
                      : 'Experience our technology firsthand through interactive demonstrations. Explore capabilities, test functionality, and visualize how our solutions can transform your operations.'}
                  </p>
                </div>
                <div className="flex justify-center">
                  <Link 
                    to="/demo" 
                    className="bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-6 rounded-lg transition duration-300 ease-in-out transform hover:scale-105 flex items-center"
                  >
                    <span>{language === 'zh' ? '探索所有演示' : 'Explore All Demos'}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            </section>
            <Stats language={language} />
            <Testimonials language={language} />
            <Careers language={language} />
            <Contact language={language} />
            <Footer language={language} />
          </div>
        } />
      </Routes>
    </Router>
  );
};

export default App;